import { render, staticRenderFns } from "./daily_bookingsv1.vue?vue&type=template&id=55671664&scoped=true"
import script from "./daily_bookingsv1.vue?vue&type=script&lang=js"
export * from "./daily_bookingsv1.vue?vue&type=script&lang=js"
import style0 from "./daily_bookingsv1.vue?vue&type=style&index=0&id=55671664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55671664",
  null
  
)

export default component.exports